/* unplugin-vue-components disabled */import script from "./deleteDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./deleteDialog.vue?vue&type=script&setup=true&lang=js"

import "./deleteDialog.vue?vue&type=style&index=0&id=59283758&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59283758"]])

export default __exports__